import { render, staticRenderFns } from "./crop-list.html?vue&type=template&id=1503a21c&scoped=true&"
import script from "./crop-list.js?vue&type=script&lang=js&"
export * from "./crop-list.js?vue&type=script&lang=js&"
import style0 from "./CropList.vue?vue&type=style&index=0&id=1503a21c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1503a21c",
  null
  
)

component.options.__file = "CropList.vue"
export default component.exports